import { CoreDialog } from '@ingenico/react-ui/core-dialog';
import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import { DialogActions, DialogTitle } from '@mui/material';
import type { Breakpoint } from '@mui/system';
import deepEqual from 'fast-deep-equal';
import type { ReactElement, ReactNode } from 'react';
import { memo } from 'react';
import styles from './CancelModal.module.scss';

export interface CancelModalInput {
  readonly actions?: ReactNode | undefined;
  readonly handleOnClose: () => void;
  readonly isOpen: boolean;
  readonly maxWidth?: Breakpoint | false;
  readonly translations: {
    readonly title: string;
    readonly subtitle: string;
    readonly buttons: {
      readonly cancel: string;
      readonly quit: string;
    };
  };
}

export function CancelModalCpnt({
  actions,
  maxWidth,
  isOpen,
  handleOnClose,
  translations,
}: CancelModalInput): ReactElement {
  return (
    <CoreDialog
      classes={{ paper: styles.paper, root: styles.host }}
      fullWidth
      maxWidth={maxWidth ?? 'sm'}
      open={isOpen}
      onClose={handleOnClose}
    >
      <DialogTitle className={styles.header}>
        <div className={styles.title}>
          <CoreTypography variant={CoreTypographyVariant.Title01Medium}>{translations.title}</CoreTypography>
          <CoreTypography variant={CoreTypographyVariant.Body02Regular}>{translations.subtitle}</CoreTypography>
        </div>
      </DialogTitle>
      {!!actions && <DialogActions className={styles.actions}>{actions}</DialogActions>}
    </CoreDialog>
  );
}

export const CancelModal = memo(CancelModalCpnt, deepEqual);
